import * as React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import './styles/NonCompliantBadge.scss';

interface Props {
  pill?: boolean;
}

export const NonCompliantBadge = ({ pill }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('non-compliant-badge', { 'is--pill': pill })}>
      <i className="material-symbols">verified_user</i>
      <strong>{t('nonCompliantBadge.label')}</strong>
    </div>
  );
};
